import { render, staticRenderFns } from "./reception.vue?vue&type=template&id=b0da80b6&scoped=true&"
import script from "./reception.vue?vue&type=script&lang=js&"
export * from "./reception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0da80b6",
  null
  
)

export default component.exports